import { render } from "./Contacts.vue?vue&type=template&id=c5b314ba&scoped=true"
import script from "./Contacts.vue?vue&type=script&lang=js"
export * from "./Contacts.vue?vue&type=script&lang=js"

import "./Contacts.vue?vue&type=style&index=0&id=c5b314ba&lang=scss&scoped=true"

import exportComponent from "C:\\BEST develop\\EJF\\best_ejf15\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5b314ba"]])

export default __exports__